import React from 'react';

function AbaInicioPainel() {
  return (
    <div className="routine-panel panel-home">
      <section className="panel-home__brand" aria-label="VMS Sistemas e Divulgações">
        <img className="panel-home__watermark" src="/logo.jpg" alt="VMS Sistemas e Divulgações" />
      </section>
    </div>
  );
}

export default AbaInicioPainel;
